import AddButton from "components/Button/AddButton";
import React, { useEffect, useState } from "react";
import TrashIcon from "assets/icon/TrashIcon";
import { useNavigate } from "react-router-dom";
import { DropdownStatusList, EmptyString, FormTypeAdd, PageSize } from "utils/Constant";
import EditIcon from "assets/icon/EditIcon";
import SearchButton from "components/Button/SearchButton";
import Dropdown from "components/Input/Dropdown";
import { GetStatus } from "utils/helpers";
import RevisionIcon from "assets/icon/RevisionIcon";
import { useModal } from "utils/context/ModalContext";
import { useCallApi } from "api/apiHooks";
import Pagination from "components/Input/PaginationButton";
import { MainBodyCard, PagesTitle } from "components/Cards";

export default function User(){
    let navigate = useNavigate()
    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { fetchUserList, fetchDeleteUser } = useCallApi()

    const [userList, setUserList] = useState([])
    const [username, setUsername] = useState(EmptyString)
    const [name, setName] = useState(EmptyString)
    const [status, setStatus] = useState(DropdownStatusList[1].value)
    const [pageIndex, setPageIndex] = useState(0)
    const [totalPages, setTotalPages] = useState(0)

    const usernameChange = (e) => { setUsername(e.target.value) }
    const nameChange = (e) => { setName(e.target.value) }
    const statusChange = (e) => { setStatus(e.value) }
    const filterEnterKeyPress = (e) => { fEnterKeyDown(e) }
    const addBtnClick = () => { navigate("/setting/user/form?userId=&formType=" + FormTypeAdd) }
    const searchBtnClick = () => { handlePageChange(0) }

    async function handlePageChange(newIndex) {
        try {
            showLoading()

            const res = await fetchUserList(username, name, status, PageSize, parseInt(newIndex))

            if (!res) return

            const totalData = res?.data?.totalData ?? 0;
            const total = Math.max(1, Math.ceil(totalData / PageSize));

            setUserList(res)
            setTotalPages(total);
            setPageIndex(newIndex);
        } finally {
            hideLoading();
        }
    }

    // Function Button
    function fEditBtnClick(userId){
        navigate("/setting/user/form?userId=" + userId + "&formType=Edit")
    }
    async function fDeleteBtnClick(userId, status){
        const isConfirmed = await confirm()

        if (isConfirmed) {
            showLoading()

            const res = await fetchDeleteUser(userId, status)

            if (!res) return

            showSuccess()
            handlePageChange(pageIndex)
        }
    }

    function fEnterKeyDown(e){
		if(e.key === 'Enter'){
			handlePageChange(0)
		}
	}

    useEffect(() => {
        handlePageChange(0)
    },[])

    return(
        <MainBodyCard>
            <PagesTitle title={'User'} />

            <div className="flex flex-col sm:flex-row gap-5 justify-between mt-5">
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full">
                    <div className="flex flex-col gap-2 w-72">
                        <span>Username</span>
                        <input className="input" value={username} onChange={usernameChange} onKeyDown={filterEnterKeyPress} />
                    </div>
                    <div className="flex flex-col gap-2 w-72">
                        <span>Name</span>
                        <input className="input" value={name} onChange={nameChange} onKeyDown={filterEnterKeyPress} />
                    </div>
                    <div className="flex flex-col gap-2 w-36">
                        <span>Status</span>
                        <Dropdown value={status} options={DropdownStatusList} onChange={statusChange} placeholder={"All"} />
                    </div>
                </div>
                <div>
                    <div className="flex justify-end items-end h-full">
                        <SearchButton onClick={searchBtnClick} />
                    </div>
                </div>
            </div>

            <div className="mt-3 flex w-full justify-end">
                <AddButton onClick={addBtnClick} title="Tambah User" />
            </div>
           
            <div className="mt-5">
                <table className="w-full border bg-white">
                    <thead>
                        <tr className="h-12">
                            <th className="font-semibold w-16">No</th>
                            <th className="font-semibold text-left px-2 hidden sm:table-cell">Username</th>
                            <th className="font-semibold text-left px-2">Name</th>
                            <th className="font-semibold text-left px-2 hidden sm:table-cell">Status</th>
                            <th className="font-semibold sm:w-24">Action</th>
                        </tr>
                    </thead>
                    <tbody className="border">
                        {userList?.data?.listData?.map((data, i) => {
                            return(
                                <tr className="my-2 row h-10 border-y hover:bg-slate-100" key={ i }>
                                    <td className="text-center">{ data.rowNumber }</td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ data.username }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.fullName }</span>
                                    </td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ GetStatus(data.status) }</span>
                                    </td>
                                    <td className="flex flex-col sm:flex-row justify-center py-2 gap-2 px-2">
                                        <button className="p-2 bg-black rounded-lg flex gap-2" onClick={() => fEditBtnClick( data.userId )}>
                                            <EditIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`p-2 bg-black rounded-lg flex gap-2 ${ data.status === "2" ? "hidden" : "block" }`} onClick={() => fDeleteBtnClick(data.userId, data.status)}>
                                            <TrashIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`p-2 bg-black rounded-lg flex gap-2 ${ data.status === "1" ? 'hidden' : 'block' }`} onClick={() => fDeleteBtnClick(data.userId, data.status)}>
                                            <RevisionIcon className="w-4 fill-white" />
                                        </button>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>

            <Pagination pageIndex={pageIndex} totalPages={totalPages} onPageChange={handlePageChange} />
        </MainBodyCard>
    )
}